import { getLocalizedTranslation } from "../../../utils/localization";
import getImageUrl from "../../../utils/getImageUrl";
import { useSelector, useDispatch } from "react-redux";
import { updateProductFunc } from "../../../store/custom-actions/products-actions/UpdateProductSlicer";
import { useTranslation } from "react-i18next";
import ToggleSwitch from "../../components/ui/ToggleSwitch";
import { formatCurrency } from "../../../utils/formatCurrency";

export default function useProductTableColumns({
    productsList,
    arrayWillDeleteIt,
    setArrayWillDeleteIt,
    handleCheckProduct,
    handleUnCheckProduct,
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { data: languageData, loading: switchLangLoading } = useSelector(
        (state) => state.getLanguageSettingsSlicer
    );

    return [
  {
    header: (
      <input
        type="checkbox"
        className="form-check-input m-0"
        style={{ cursor: "pointer", transform: "scale(1.1)", verticalAlign: "middle" }}
        onChange={(e) =>
          setArrayWillDeleteIt(
            e.target.checked ? productsList.map((p) => p.id) : []
          )
        }
        checked={
          arrayWillDeleteIt.length > 0 &&
          arrayWillDeleteIt.length === productsList.length
        }
      />
    ),
    render: (product) => (
      <input
        type="checkbox"
        checked={arrayWillDeleteIt.includes(product.id)}
        onChange={(e) =>
          e.target.checked
            ? handleCheckProduct(product.id)
            : handleUnCheckProduct(product.id)
        }
        className="form-check-input"
        style={{ cursor: "pointer", transform: "scale(1.1)" }}
      />
    ),
  },
  {
    header: t("Product"),
    render: (product) => {
      const name =
        getLocalizedTranslation(
          product.translations,
          languageData?.defaultLang?.slug
        )?.title || "";
      return (
        <div className="d-flex align-items-center">
          <img
            src={getImageUrl(product?.thumbnail?.path)}
            className="me-2 rounded-circle"
            style={{ width: "30px", height: "30px", objectFit: "cover" }}
            alt="product"
          />
          <div>
            <div className="fw-medium">
              {switchLangLoading ? `${t("Loading")}...` : name}
            </div>
            <small className="text-muted">SKU: {product.sku}</small>
          </div>
        </div>
      );
    },
  },
  {
    header: t("Category"),
    render: (product) => {
      const name = getLocalizedTranslation(
        product?.category?.translations,
        languageData?.defaultLang?.slug
      )?.name;
      return switchLangLoading ? `${t("Loading")}...` : name;
    },
  },
  {
    header: t("Price"),
    render: (product) => {
      const hasDiscount = parseInt(product.discount) >= 1;
      const discountText = hasDiscount
        ? product.discount_type === "fixed"
          ? formatCurrency(product.discount)
          : `${product.discount}%`
        : null;
      
     return (
  <div className="d-flex flex-column gap-1">
    {/* Final Price */}
    <div className="fw-bold fs-5 text-dark">
      {formatCurrency(product.final_price)}
    </div>

    {/* Old Price + Discount */}
    {hasDiscount && (
      <div className="d-flex align-items-center gap-2">
        {/* Old Price */}
        <span className="text-muted text-decoration-line-through small">
          {formatCurrency(product.price)}
        </span>

        {/* Discount Badge */}
        <span className="badge bg-danger-subtle text-danger border border-danger-subtle">
          {discountText}
        </span>
      </div>
    )}
  </div>
);
    },
  },
  {
    header: t("Status"),
    render: (product) => (
      <ToggleSwitch
        value={product.active}
        onChange={(val) =>
          dispatch(
            updateProductFunc({
              id: product.id,
              data: { active: val },
            })
          )
        }
      />
    ),
  },
  {
    header: t("Rec"),
    render: (product) => (
      <ToggleSwitch
        value={product.recomended}
        onChange={(val) =>
          dispatch(
            updateProductFunc({
              id: product.id,
              data: { recomended: val },
            })
          )
        }
      />
    ),
  },
  // {
  //   header: t("B. Sell"),
  //   render: (product) => (
  //     <ToggleSwitch
  //       value={product.best_selling}
  //       onChange={(val) =>
  //         dispatch(
  //           updateProductFunc({
  //             id: product.id,
  //             data: { best_selling: val },
  //           })
  //         )
  //       }
  //     />
  //   ),
  // },
];

}
